export const WARRANTY_BASE = "/warranty";

export const warrantyPaths = {
  base: () => WARRANTY_BASE,
  investigate: (passportId?: string) =>
    passportId
      ? `${WARRANTY_BASE}/investigate/${passportId}`
      : `${WARRANTY_BASE}/investigate`,
  claims: (passportId?: string) =>
    passportId
      ? `${WARRANTY_BASE}/claims?passportId=${encodeURIComponent(passportId)}`
      : `${WARRANTY_BASE}/claims`,
  claimDetail: (id: string) => `${WARRANTY_BASE}/claims/${id}`,
  thresholds: () => `${WARRANTY_BASE}/thresholds`,
  exposure: () => `${WARRANTY_BASE}/exposure`,
};
